import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';
import { useZendesk } from 'Utilities/hooks/useZendesk';

import LocalTexts from './CancellationAndPriceAdjustmentsPolicy.texts.json';

import styles from '../StaticContents.module.scss';

const T = new MDText(LocalTexts);

const CancellationAndPriceAdjustments: React.FC = () => {
	const { adjustmentsAndCancellationsLink } = useZendesk();

	const formLink = (
		<a
			href={adjustmentsAndCancellationsLink}
			{...applyCypressData(cypressIds.links.adjustmentAndCancellations)}
			target="_blank"
		>
			{T.translate('formLinkText')}
		</a>
	);

	return (
		<div className={cx(styles.staticContents, styles.container)}>
			<h1>{T.translate('title')}</h1>
			<p>{T.translate('paragraphs.1')}</p>
			<p>{T.translate('paragraphs.2')}</p>
			<p>{T.translate('paragraphs.3')}</p>
			<ol>
				<li>{T.translate('additionalDamagePoints.1')}</li>
				<li>{T.translate('additionalDamagePoints.2', { formLink })}</li>
				<li>{T.translate('additionalDamagePoints.3')}</li>
			</ol>
			<p>{T.translate('paragraphs.4')}</p>
			<ol>
				<li>{T.translate('otherCancellationsPoints.1', { formLink })}</li>
				<li>{T.translate('otherCancellationsPoints.2')}</li>
			</ol>
			<p>{T.translate('paragraphs.5')}</p>
			<p>{T.translate('paragraphs.6')}</p>
			<p>{T.translate('paragraphs.7')}</p>
			<p>{T.translate('paragraphs.8')}</p>
			<p>{T.translate('paragraphs.9')}</p>
		</div>
	);
};

export default CancellationAndPriceAdjustments;
